import React, { useEffect, useState } from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import PropTypes from 'prop-types';

import Header from './components/layout/Header';
import Nav from './components/layout/Navigation';
import About from './pages/about/About';
import Experience from './pages/experience/Experience';

// 🔒 TEMP DISABLED - SKILL & SERVICES
// import Skill from './pages/skill/Skill';
// import Services from './pages/services/Services';

import Portfolio from './pages/portfolio/Portfolio';
import Achievement from './pages/achievement/Achievement';
import Contact from './pages/contact/Contact';
import Footer from './components/layout/Footer';
import Theme from './components/layout/Theme';
import ErrorBoundary from './components/common/ErrorBoundary';

const RouterWrapper = ({ children }) => (
  <Router>
    <Nav />
    <Theme />
    {children}
    <Footer />
  </Router>
);

RouterWrapper.propTypes = {
  children: PropTypes.node.isRequired
};

const App = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <ErrorBoundary>
      <RouterWrapper>
        {screenWidth > 600 ? (
          <Routes>
            <Route path="/" element={<Header />} />
            <Route path="/about" element={<About />} />
            <Route path="/experience" element={<Experience />} />

            {/* 🔒 TEMP DISABLED - SKILL & SERVICES */}
            {/* <Route path="/skill" element={<Skill />} /> */}
            {/* <Route path="/services" element={<Services />} /> */}

            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/achievement" element={<Achievement />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        ) : (
          <>
            <Header />
            <About />
            <Experience />

            {/* 🔒 TEMP DISABLED - SKILL & SERVICES */}
            {/* <Skill /> */}
            {/* <Services /> */}

            <Portfolio />
            <Achievement />
            <Contact />
          </>
        )}
      </RouterWrapper>
    </ErrorBoundary>
  );
};

export default App;